// Car sizes — the web's copy of ParksphereMobileApp/utils/carSize.js; keep the two the same.
//
// 2026-10-28: three sizes instead of eight car types (server/utils/carTypes.js has the reasons). The
// examples are part of the definition: the fit filter compares one person's choice with another's,
// so it only works if everyone puts the same car in the same size.
export const CAR_SIZES = [
  { value: 'small', label: 'Small', examples: 'Fiat 500, Toyota Aygo, Smart' },
  { value: 'medium', label: 'Medium', examples: 'VW Golf, Toyota Corolla, Mazda 3' },
  { value: 'large', label: 'Large', examples: 'SUVs, estates, vans: Toyota RAV4, VW Passat estate' },
];

// The old vocabulary, for anything cached before the server migrated it.
const LEGACY = {
  'city car': 'small',
  hatchback: 'medium',
  sedan: 'medium',
  'family car': 'large',
  suv: 'large',
  van: 'large',
  truck: 'large',
};

export function normalizeCarSize(value) {
  if (typeof value !== 'string') return null;
  const key = value.trim().toLowerCase();
  if (CAR_SIZES.some((s) => s.value === key)) return key;
  return LEGACY[key] ?? null;
}

/** "Medium", or null when there is no size to show. */
export function carSizeLabel(value) {
  const size = normalizeCarSize(value);
  return size ? CAR_SIZES.find((s) => s.value === size).label : null;
}
